var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5L4 21L20 21L20 5L22 5L22 3L2 3L2 5L4 5ZM11 19L9.5 19L9.5 5L11 5L11 19ZM13 5L14.5 5L14.5 19L13 19L13 5ZM18 19L16.5 19L16.5 5L18 5L18 19ZM7.5 5L7.5 19L6 19L6 5L7.5 5Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashbin);
export default __webpack_public_path__ + "static/media/trashbin.fe34379cf0683a94962aee4cb4b9f5f8.svg";
export { ForwardRef as ReactComponent };